/**
 * @fileoverview Сближения и уступки на земле.
 */

import { Snd } from "../audio/sound";
import type { GameHooks, GameState, Plane } from "../state/types";
import { dist } from "../util/math";
import { taxiCollision } from "./collisions";

function isMoving(p: Plane): boolean {
  return (
    p.status === "taxi_gate" ||
    p.status === "taxi_rwy" ||
    p.status === "vacating" ||
    (p.status === "awaiting_gate" && !!p.path?.length)
  );
}

function facing(m: Plane, o: Plane): boolean {
  if (!m.path?.length) return false;
  const da = Math.cos(Math.atan2(o.y - m.y, o.x - m.x) - m.ang);
  return da > 0.25;
}

/** Тик ground traffic: yield, near-miss hazard, столкновения. */
export function updateGroundTraffic(
  g: GameState,
  hooks: GameHooks,
  dt: number,
): void {
  const ground = g.planes.filter(
    (p) =>
      !p.dead &&
      (p.status === "taxi_gate" ||
        p.status === "taxi_rwy" ||
        p.status === "vacating" ||
        p.status === "awaiting_gate" ||
        p.status === "hold_short" ||
        p.status === "ready" ||
        p.status === "service"),
  );

  for (let i = 0; i < ground.length; i++) {
    const a = ground[i]!;
    a.yieldT = Math.max(0, a.yieldT - dt);
    for (let j = i + 1; j < ground.length; j++) {
      const b = ground[j]!;
      const d = dist(a.x, a.y, b.x, b.y);
      if (!isMoving(a) && !isMoving(b)) continue;

      if (a._taxiLock || b._taxiLock) {
        if (d > 55) {
          a._taxiLock = false;
          b._taxiLock = false;
        }
        if (d < 58) {
          a.warn = Math.max(a.warn, 0.4);
          b.warn = Math.max(b.warn, 0.4);
        }
        continue;
      }

      if (d >= 78) continue;

      const af = facing(a, b);
      const bf = facing(b, a);
      if (d > 36) {
        if (af && bf) {
          const y =
            (a.path?.length || 0) >= (b.path?.length || 0) ? a : b;
          y.yieldT = Math.max(y.yieldT || 0, 0.55);
        } else if (af) a.yieldT = Math.max(a.yieldT || 0, 0.55);
        else if (bf) b.yieldT = Math.max(b.yieldT || 0, 0.55);
        else if (isMoving(a)) a.yieldT = Math.max(a.yieldT || 0, 0.35);
        else if (isMoving(b)) b.yieldT = Math.max(b.yieldT || 0, 0.35);
      }

      if (d < 58) {
        a.warn = Math.max(a.warn, 0.5);
        b.warn = Math.max(b.warn, 0.5);
      }

      if (d < 32) {
        taxiCollision(g, hooks, a, b);
      } else if (
        d < 42 &&
        !g.hazards.some(
          (h) =>
            h.kind === "near" &&
            ((h.p === a && h.q === b) || (h.p === b && h.q === a)),
        )
      ) {
        g.hazards.push({ kind: "near", p: a, q: b, r: null, t: 2.2, max: 2.2 });
        Snd.warn();
        g.flash = 0.45;
        hooks.toast(
          `ОПАСНОЕ СБЛИЖЕНИЕ: ${a.cs} / ${b.cs} — разведите или ждите`,
          "bad",
        );
      }
    }
  }
}
